import { combineReducers } from 'redux';

import login from './login.reducer';
import master from './master.reducer';
import tenant from './tenant.reducer';

const authReducers = combineReducers({
  master,
  login,
  tenant,
});

export default authReducers;
